import { getParent, getRoot, types as t } from 'mobx-state-tree';

import { ERROR_NEED_OVERRIDE } from '../../question-data-model/constants';
import { KeyValueModel } from '../../question-data-model/key-value.store';
import { AbstractQuestion } from '../../question-data-model/Question/abstract-question.store';

export const ResultTestQuestionStore = AbstractQuestion.named('ResultTestQuestionStore')
  .props({
    isLocateExplanation: t.array(KeyValueModel),
  })
  .views((self) => ({
    getQuestions() {
      throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
    },
    get questionCount(): number {
      throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
    },
    get isLocateExplanationEnabled() {
      const root: any = getRoot(self);
      return (
        self.isLocateExplanation.find((kv) => kv.key === root.currentQuestionIndex)?.value ===
        'enabled'
      );
    },
  }))
  .views((self) => ({
    get no(): number {
      let questionNo = 1;
      let isFound = false;

      const updateQuestionNo = (questions) => {
        questions.forEach((question) => {
          if (question.uuid === self.uuid) {
            isFound = true;
          }
          if (!isFound) {
            questionNo += question.questionCount;
          }
        });
      };

      try {
        const test = getParent<any>(self, 6);
        if (test?.testSections?.length > 0) {
          test.testSections.forEach((testSection) => {
            testSection.questionGroups.forEach((group) => {
              updateQuestionNo(group.questions);
            });
          });
          return questionNo;
        }

        // eslint-disable-next-line no-empty
      } catch (ex) {}

      const test = getParent<any>(self, 2);
      updateQuestionNo(test.questions);

      return questionNo;
    },
  }))
  .actions((self) => ({
    toggleLocateExplanation() {
      const root: any = getRoot(self);
      const isExist = self.isLocateExplanation.find((kv) => kv.key === root.currentQuestionIndex);
      if (isExist) {
        const isDisabled = isExist.value !== 'enabled';
        isExist.setValue(isDisabled ? 'enabled' : '');
        return;
      }
      self.isLocateExplanation.push({
        key: root.currentQuestionIndex,
        value: 'enabled',
      });
    },
  }));
